import React, { Component } from "react";
import { connect } from "react-redux";
import actions from "actions";
import parse from "html-react-parser";
import PropTypes from "prop-types";

const { loadAboutDataUserSaga } = actions;

class AboutUs extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.props.loadAboutData();
  }

  render() {
    const { body, footer, founders } = this.props.aboutData;

    return (
      <main className="site--width">
        <div className="plain_content">
          <h2 className="main_title">ABOUT US</h2>
          <div>
            {body && parse(body)}

            <div className="founders_container">
              {founders && founders.length
                ? founders.map((founder) => (
                    <div className="founder_logo founder_logo_resize">
                      {founder && founder.avatar && founder.avatar.url && (
                        <img src={founder.avatar.url} alt={founder.name} />
                      )}
                      <p className="founder_label">
                        {" "}
                        {founder && founder.name && founder.name}{" "}
                      </p>
                    </div>
                  ))
                : null}
            </div>

            {footer && parse(footer)}
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  aboutData: state.landingData.about_us,
});

const mapDispatchToProps = (dispatch) => ({
  loadAboutData: () => dispatch(loadAboutDataUserSaga()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AboutUs);



// WEBPACK FOOTER //
// ./src/components/Plain/AboutUs.jsx